module.exports = __webpack_public_path__ + "1793882494189/images/mastercard.7bbc1c0.png";